<template>
  <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="120px" size="medium">
    <el-form-item label="告警模式" prop="noticeMod">
      <el-select v-model="formData.noticeMod">
        <el-option label="告警立刻上报" :value="0"></el-option>
        <el-option label="循环报警" :value="1"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-if="formData.noticeMod === 1" label="告警频率(分)" prop="noticeTime">
      <el-input type="number" v-model="formData.noticeTime" ></el-input>
    </el-form-item>
    <el-form-item v-if="formData.noticeMod === 1" label="最大告警条数" prop='noticeNum'>
      <el-input type="number" v-model="formData.noticeNum" ></el-input>
    </el-form-item>
    <el-form-item label="是否语音告警" prop="delFlag">
      <el-switch v-model="formData.delFlag" :active-value="0" :inactive-value="1"></el-switch>
    </el-form-item>
    <el-form-item class="standard-form-bottom">
      <el-button v-on:click="closeDialog">取消</el-button>
      <el-button type="primary" v-on:click="saveRole">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {Message} from 'element-ui'

export default {
  name: "NoticeDialog",
  props: ['userId'],
  created() {
    this.initData();
  },
  data() {
    return {
      formData: {
        noticeMod: '',
        noticeTime: '',
        noticeNum: '',
        delFlag: ''
      },
      rules: {
        noticeMod: [
          { required: true, message: '请输入告警模式', trigger: 'blur' }
        ],
        noticeTime: [
          { required: true, message: '请输入告警频率', trigger: 'blur' }
        ],
        noticeNum: [
          { required: true, message: '请输入最大告警条数', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog', this.formData);
    },
    initData() {
      this.$api.energyMonitor.getNoticeInfo(this.userId).then(res => {
        if(res.code !== 500) {
          this.formData.noticeMod = res.data.noticeMod;
          this.formData.noticeTime = res.data.noticeTime;
          this.formData.noticeNum = res.data.noticeNum;
          this.formData.delFlag = res.data.delFlag;
        }else {
          Message.warning(res.message)
        }
      });
      this.resetForm('ruleForm')
    },
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
    },
    saveRole() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let params = {
            "userId": this.userId,
            "noticeMod": this.formData.noticeMod,
            "noticeTime": this.formData.noticeTime,
            "noticeNum": this.formData.noticeNum,
            "delFlag": this.formData.delFlag
          };
          this.$api.energyMonitor.updateNoticeInfo(params).then(res => {
            if(res.code === 200) {
              this.$emit('closeDialog');
              Message.success(res.message)
            }else {
              Message.warning(res.message)
            }
          })
        }else {
          return false;
        }
      })
    }
  }
}
</script>

<style scoped>
  .tree-container{
    overflow-y: auto;
    width: 528px;
    height: 260px;
    border: 1px solid #D2D2D2;
  }
  .hide{
    width: 0;
    position: absolute
  }
  .standard-form-bottom{
    width: 100%;
    text-align: right
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/NoticeDialog.vue